import { Fade } from "react-awesome-reveal";
import { useLoader } from "../../context/LoaderContext";
import { INewsLetterData } from "../../exports/interfaces";

const AllNewsLetter = (props: { newsLetterData: INewsLetterData[] }) => {
  const { loading } = useLoader();
  return (
    <section className="events-page">
      <div className="container">
        <div className="row">
          {!loading &&
            props.newsLetterData?.map((news, index) => (
              <div className="col-xl-3 col-lg-6 col-md-6" key={news.id}>
                <Fade
                  key={index}
                  cascade
                  damping={0.2}
                  triggerOnce={true}
                  delay={index * 200}
                >
                  <div className="events__single">
                    <div className="events__img">
                      <img
                        src={`${process.env.REACT_APP_strapiUrl}${news?.attributes?.Image?.data?.attributes?.url}`}
                        alt="news-letter-image"
                        style={{
                          objectFit: "cover",
                          // height: "200px",
                          height: "225px",
                        }}
                      />
                      {/* <div className="events__date">
                    <p>{event?.attributes?.Date}</p>
                  </div> */}
                    </div>
                    <div className="events__content">
                      <h3 className="events__title">
                        {/* <Link
                      to="/events/events-details"
                      state={{
                        id: event.id,
                        bannerUrl: props?.eventBannerImage
                      }}
                    > */}
                        {news?.attributes?.Name}
                        {/* </Link> */}
                      </h3>
                      {/* <ul className="list-unstyled events__meta"> */}
                      {/* <li>
                      <i className="far fa-clock"></i>
                      {event?.attributes?.Time}
                    </li>
                    <li>
                      <i className="fas fa-map-marker-alt"></i>
                      {event?.attributes?.Event_Location}
                    </li> */}
                      <div className="custom-newsletter-button">
                        <a
                          href={`${process.env.REACT_APP_strapiUrl}${news?.attributes?.File?.data?.attributes?.url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="thm-btn main-header-two__btn custom-main-header-two__btn custom-donate-btn"
                        >
                          {" "}
                          {/* <i className="fa fa-heart"></i>  */}
                          View
                        </a>
                      </div>
                      {/* </ul> */}
                    </div>
                  </div>
                </Fade>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default AllNewsLetter;
